import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const propTypes = {
  as: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  value: PropTypes.string.isRequired,
  format: PropTypes.string,
  className: PropTypes.string
};

const defaultProps = {
  as: 'span',
  format: 'MM/DD'
};

function FormattedDate({ value, format, as: T, ...props }) {
  return <T {...props}>{moment(value).format('MM/DD')}</T>;
}

FormattedDate.propTypes = propTypes;
FormattedDate.defaultProps = defaultProps;

export default FormattedDate;
